<template>
    <div class="card mb-0 shadow">
        <div class="card-body p-2">
            <div class="row" style="height: calc(100vh - 130px)">
                <div
                    class="col-4"
                    v-show="size > 0"
                    style="height: 85vh; overflow-y: auto"
                >
                    <SupportList @selected="setSupport" @size="setSize" />
                </div>
                <div :class="`${size > 0 ? 'col-8' : 'col-12'}`">
                    <!-- <a
                        v-if="setSupport"
                        class="d-flex align-items-center btn btn-primary px-2"
                        @click="mode = 'list'"
                    >
                        <i class="mdi mdi-24px mdi-arrow-left"></i>
                        <h4 class="m-0 text-white">
                            Voltar para lista de Suportes
                        </h4>
                    </a> -->
                    <ChatBox
                        mode="page"
                        :selected="selected"
                        @novo="selected = null"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatBox from "@/dashboard/components/widgets/support/ChatBoxSuporte";
import SupportList from "./includes/SupportList.vue";

export default {
    components: {
        ChatBox,
        SupportList,
    },
    data() {
        return { selected: null, size: 0 };
    },
    methods: {
        setSupport(id) {
            this.selected = id;
        },
        setSize(size) {
            this.size = size;
        },
    },
};
</script>
